import type { SvgIconProps } from '@mui/material'
import { SvgIcon } from '@mui/material'
import { useTheme } from '../../basics/theme'

type DirectionalMapMarkerIconProps = SvgIconProps & {
  inService?: boolean
  heading?: number
}

export const DirectionalMapMarkerIcon = ({
  inService,
  heading,
  ...props
}: DirectionalMapMarkerIconProps) => {
  const theme = useTheme()

  return (
    <SvgIcon
      viewBox="0 0 40 41"
      xmlns="http://www.w3.org/2000/svg"
      css={{
        ...(heading !== undefined && {
          transition: 'transform 0.3s ease-in-out',
          transform: `rotate(${heading}deg)`,
        }),
      }}
      {...props}
    >
      <path
        opacity="0.8"
        d="M16.8247 3.31756C18.3176 0.611852 22.3323 0.701776 23.6575 3.58756L37.4385 33.6016L37.4392 33.6023C39.0095 37.0271 35.2143 40.4269 31.9819 38.492L31.9812 38.4913L20.191 31.4244L8.35526 38.5079C5.1242 40.4407 1.33333 37.0423 2.90349 33.6182L16.6886 3.58756L16.8247 3.31756Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M18.5047 4.42173C19.1591 2.99687 21.185 2.99759 21.8393 4.42242L35.6203 34.4365C36.3711 36.0744 34.5568 37.7009 33.0101 36.776L20.7075 29.4011C20.4307 29.2351 20.0928 29.2139 19.8009 29.3383L19.6793 29.4004L7.32843 36.7919C5.8322 37.6866 4.08219 36.1896 4.65814 34.605L4.72098 34.4524L18.5061 4.42173H18.5047Z"
        stroke="#000C15"
        strokeWidth="2"
        strokeLinejoin="round"
        fill="none"
      />
      <rect
        x="14.5"
        y="15.5"
        width="11"
        height="11"
        rx="5.5"
        fill={
          inService
            ? theme.semantic.ColorSuccessDefault
            : theme.semantic.ColorCriticalDefault
        }
        stroke="white"
      />
    </SvgIcon>
  )
}
